/* Copy link on the article pages. Nothing else on this page needs JavaScript. */
document.addEventListener('click', function (event) {
  var button = event.target.closest && event.target.closest('[data-fa-copy]');
  if (!button) return;
  var url = button.getAttribute('data-fa-copy');
  var done = function () {
    var was = button.textContent;
    button.textContent = 'Link copied';
    setTimeout(function () {
      button.textContent = was;
    }, 2000);
  };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url).then(done).catch(function () {});
  }
});
